// import React from "react";
// import Particles from "react-particles-js";

// function Particle() {
// 	return (
// 		<Particles
// 			id="particles-js"
// 			params={{
// 				particles: {
// 					number: {
// 						value: 80,
// 						density: {
// 							enable: true,
// 							value_area: 900,
// 						},
// 					},
// 					color: {
// 						value: "#fff",
// 					},
// 					shape: {
// 						type: "circle",
// 						stroke: {
// 							width: 0,
// 							color: "#c4932f",
// 						},
// 						polygon: {
// 							nb_sides: 5,
// 						},
// 						image: {
// 							src: "img/github.svg",
// 							width: 100,
// 							height: 100,
// 						},
// 					},
// 					opacity: {
// 						value: 0.5,
// 						random: false,
// 						anim: {
// 							enable: false,
// 							speed: 1,
// 							opacity_min: 0.3,
// 							sync: false,
// 						},
// 					},
// 					size: {
// 						value: 3,
// 						random: true,
// 						anim: {
// 							enable: false,
// 							speed: 50,
// 							size_min: 0.1,
// 							sync: false,
// 						},
// 					},
// 					line_linked: {
// 						enable: true,
// 						distance: 150,
// 						color: "#c4932f",
// 						opacity: 0.7,
// 						width: 1.5,
// 					},
// 					move: {
// 						enable: true,
// 						speed: 1,
// 						direction: "none",
// 						random: false,
// 						straight: false,
// 						out_mode: "out",
// 						bounce: false,
// 						attract: {
// 							enable: false,
// 							rotateX: 600,
// 							rotateY: 1200,
// 						},
// 					},
// 				},
// 				interactivity: {
// 					detect_on: "window",
// 					events: {
// 						onhover: {
// 							enable: true,
// 							mode: "grab",
// 						},
// 						onclick: {
// 							enable: true,
// 							mode: "push",
// 						},
// 						resize: true,
// 					},
// 					modes: {
// 						grab: {
// 							distance: 150,
// 							line_linked: {
// 								opacity: 1,
// 							},
// 						},
// 						bubble: {
// 							distance: 400,
// 							size: 40,
// 							duration: 2,
// 							opacity: 8,
// 							speed: 3,
// 						},
// 						repulse: {
// 							distance: 200,
// 							duration: 0.4,
// 						},
// 						push: {
// 							particles_nb: 4,
// 						},
// 						remove: {
// 							particles_nb: 2,
// 						},
// 					},
// 				},
// 				retina_detect: true,
// 			}}
// 		/>
// 	);
// }

// export default Particle;

import React from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const ParticlesBackground = () => {
  const particlesInit = async (main) => {
    // you can initialize the tsParticles instance (optional)
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };

  return (
    <Particles
      id='tsparticles'
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: 'transparent',
          },
        },
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: { enable: true, mode: 'push' },
            onHover: { enable: true, mode: 'repulse' },
            resize: true,
          },
          modes: {
            push: { quantity: 4 },
            repulse: { distance: 100, duration: 0.4 },
          },
        },
        particles: {
          color: { value: '#fff' },
          links: { enable: true, color: '#c4932f', distance: 150, opacity: 0.7, width: 1 },
          collisions: { enable: true },
          move: { enable: true, speed: 1.5, direction: 'none', random: false, straight: false, outModes: 'out' },
          number: { value: 80, density: { enable: true, area: 800 } },
          opacity: { value: 0.5 },
          shape: { type: 'circle' },
          size: { value: { min: 1, max: 5 } },
        },
        detectRetina: true,
      }}
    />
  );
};

export default ParticlesBackground;
